import { FC } from "react"
import { Aside } from "./Aside"
import { useElements, useStripe } from "@stripe/react-stripe-js"

interface AsideInsideElementsProps {
	clientSecret?: string
	stripeComplete: boolean,
}

export const AsideInsideElements:FC<AsideInsideElementsProps> = ({stripeComplete, clientSecret}) => {

    const stripeState = useElements()
    const stripe = useStripe()

    return (
        <Aside stripeState={stripeState} stripeComplete={stripeComplete} clientSecret={clientSecret} stripe={stripe}/>
    )
}